<template>
  <div class="container">
    <el-page-header @back="goBack" content="提现" class="back"></el-page-header>
    <div class="icon-suitcase" @click="cashLog">
      <i class="el-icon-suitcase-1"></i>
    </div>
    <div class="content">
      <el-col>
        <el-form ref="form">
          <el-row>
            <el-col>
              <el-form-item :label="cash">
                <span class="moneyCount">￥{{ currentBalance || 0 }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="支付方式">
            <el-tag class="cash-tag" v-model="transfer_type">银行卡提现</el-tag>
          </el-form-item>

          <div>
            <el-form-item label="银行">
              <el-input placeholder="请填写开户行" v-model="bankType"></el-input>
            </el-form-item>
            <el-form-item label="户主">
              <el-input placeholder="户主" v-model="bank_account"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input placeholder="银行卡号" v-model="bankCard"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="提现金额">
            <el-input placeholder="请填写提现金额" min="0" v-model="cashFee" type="number"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="addBtn" @click="addCash">提现</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>
<script>
import util from "@/utils";
import { addCashout, getWallet } from "@/api/index.js";
export default {
  data () {
    return {
      cashFee: "",
      changeMoney: "", //购汇价格
      bankCard: "",
      bankType: "",
      currencyType: "",
      swiftCode: "",
      currency: "",
      currentBalance: "",
      bank_account: "",
      transfer_access: "", //非银转账账户
      transfer_type: "0", //转账类型 0 银行 1 alipay 2 微信 3 PayPal
      cash: "可以提现金额：",
    };
  },
  created () {
    this.getCashInfo();
  },
  methods: {
    goBack () {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/index/user/wallet",
      });
    },
    /**
     * 进入日志
     */
    cashLog () {
      this.$router.push({
        path: "/index/user/wallet/cashLog",
      });
    },
    async addCash () {
      try {
        if (this.transfer_type === "") {
          this.elementTips("error", "请至少选择一种付款类型");
          return;
        }
        if (this.cashFee === "" || this.cashFee <= 0) {
          this.elementTips("error", "请输入正确的金额");
          return;
        }
        if (this.cashFee > this.currentBalance) {
          this.elementTips("error", "提现金额超出可提现金额，请重新填写");
          return;
        }

        if (this.transfer_type === "0") {
          if (this.bank_account === "") {
            this.elementTips("error", "户主不能为空");
            return;
          }
          if (this.bankType === "") {
            this.elementTips("error", "请填写银行类型");
            return;
          }
          if (this.bankCard === "") {
            this.elementTips("error", "请填写银行卡号");
            return;
          }
        }

        const params = {
          money: this.cashFee,
          token: util.getStore("user_token"),
          card: this.bankCard,
          bank: this.bankType,
          type: "￥",
          name: this.bank_account,
        };
        let res = await addCashout(params).then(this.callbackHandle);
        if (res.success) {
          this.elementTips("success", res.message);
          setTimeout(() => {
            this.$router.go(-1); //返回上一层
          }, 2000);
        } else if (res.code === 1000017) {
          this.elementTips("error", res.message);
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     *获取可提现余额
     * */
    async getCashInfo () {
      try {
        const params = {};
        let res = await getWallet(params);
        if (res.success) {
          this.currentBalance = res.result.currentBalance;
        } else {
          this.elementTips("error", res.messages);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  display: flex;
  flex-direction: column;
}

.el-form {
  position: relative;
  left: 15%;
}

/deep/ .el-form-item__label {
  text-align: left !important;
}

.el-input {
  width: 50%;
}

.container {
  width: 100%;
  height: 100%;
  margin: 20px;
}
.myCash {
  text-align: left;
}

.moneyCount {
  margin-left: 20px;
  font-family: arial, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #ad0707;
}

.selectBox {
  width: 100%;
}

.resStep span img {
  width: 325px;
  height: 44px;
}

.radioBtn label {
  width: 60px;
  height: 20px;
}

.radioBtn label img {
  width: 30px;
  height: 30px;
}

.addBtn {
  /* background: #04ae4e; */
  margin-top: 30px;
  width: 30%;
  background: #fc701a;
  border-color: #fc701a;
  position: relative;
  left: 15%;
}

.changeMoneyContent .cashNumber {
  font-size: 18px;
  color: #ad0707;
  /* font-weight bold; */
  margin-left: 30px;
}

.changeMoneyContent .tips {
  /* background aliceblue; */
  padding: 5px;
  font-size: 12px;
  color: #9e9e9e;
}

.transfer_type {
  margin: 20px 0 40px 0;
}
.icon-suitcase {
  float: right;
  margin-top: -20px;
  margin-right: 30px;
  font-size: 25px;
  color: #00afff;
}
// /deep/.back{
//   margin-left: 100px;
// }
.content {
  margin: 50px 20px 20px 20px;
}

.cash-tag {
  background: #f3dccd !important;
  border-color: #f3dccd !important;
  color: #fc701a;
}
</style>
